// Il menu di "Utenti e accessi". L'ordine è quello del lavoro: si guarda com'è messa la piattaforma,
// si lavora su persone e spazi, si controllano i privilegi, si indaga.
export default [
  { label: "Panoramica", icon: "ri-dashboard-2-line", to: "/accessi/panoramica" },
  { label: "Utenti", icon: "ri-user-3-line", to: "/accessi/utenti" },
  { label: "Utenti collegati", icon: "ri-pulse-line", to: "/accessi/collegati" },
  { label: "Amministratori", icon: "ri-shield-star-line", to: "/accessi/amministratori" },
  { label: "Spazi", icon: "ri-building-line", to: "/accessi/spazi" },
  { label: "Consumi", icon: "ri-money-euro-circle-line", to: "/accessi/consumi" },
  { label: "Gruppi", icon: "ri-group-line", to: "/accessi/gruppi" },
  { label: "Matrice", icon: "ri-grid-line", to: "/accessi/matrice" },
  { label: "Catalogo", icon: "ri-list-check-2", to: "/accessi/catalogo" },
  { label: "Verifica accesso", icon: "ri-eye-line", to: "/accessi/verifica" },
  { label: "Storico", icon: "ri-history-line", to: "/accessi/storico" },
  { label: "Note di rilascio", icon: "ri-megaphone-line", to: "/accessi/rilasci" },
];
